import type { UiRoot } from "../ui/UiRoot";
import type { Scene } from "./Scene";

export class TutorialScene implements Scene {
  readonly id = "tutorial" as const;
  constructor(private readonly ui: UiRoot) {}
  enter(): void {
    this.ui.show("none");
  }
  exit(): void {}
}
